import { Component, OnInit } from '@angular/core';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { PeticionesHttpBackEndService } from '../@core/mock/peticiones-http-backend.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ModalQuieroSerSocioComponent } from '../custom_components/modal-quiero-ser-socio/modal-quiero-ser-socio.component';
import { MatDialog } from '@angular/material';
import { UtilidadesService } from '../@core/utils/utilidades.service';


declare var $: any;

@Component({
  selector: 'ngx-public',
  templateUrl: './public.component.html',
  styles: [`
  :host /deep/ ul li {
    font-size:1.1em;
    list-style-type: none !important;
    color: #5dcfe3;
    cursor:pointer;
  }
  :host /deep/ ul li:hover{
    text-decoration: underline;
  }
  `],
  providers: [PeticionesHttpBackEndService]
})



export class PublicComponent implements OnInit {

  tokenRequest: any;
  Logeado: Boolean = false;
  ResultadoRequest: any;
  parametrosUrl: any;
  Usuario: any =null;
  usuarioCargado = false;
  avisoSerSocio:boolean = false;
  avisoEmpresa:boolean = false;

  constructor(private authService: NbAuthService, private _http: PeticionesHttpBackEndService, private _route: ActivatedRoute,private router:Router,public dialog: MatDialog,public utilidades: UtilidadesService) { 
    this.ResultadoRequest = {Code:false};
    this._route.queryParams.subscribe(params => {
      this.parametrosUrl = params || null;
    });
  }

irCambiarPass(){
  this.router.navigate(['private/cambiar-password']);
}
irPestaniaSocial(){
  this.router.navigate(['private/pestania-social']);
}
  checkToken(): void{
    this.authService.getToken()
      .subscribe((token: NbAuthJWTToken) => {
        if (token.isValid()) {
          this.tokenRequest = token;
          this.Logeado = true;
          this._http.checkToken().subscribe(
            result => {
              this.ResultadoRequest = result;
              if (this.ResultadoRequest.Code == 200){
                this.Logeado = true;
                this._http.getUsuario().subscribe(
                  result => {
                    this.Usuario = result;
                    if(this.Usuario != null && !this.Usuario.Entidad._es_socio){
                      this.avisoSerSocio = true;
                    }
                    if(!this.Usuario.Entidad._es_empresa_institucion){
                      this.avisoEmpresa = true;
                    }else{
                      this.avisoEmpresa = false;
                    }
                    this.usuarioCargado = true;
                  }
                )
              }else{
                /* Si da error */
                this.Logeado = false;
              }
            },
            error => {
              if (error.status == 401){
                this.Logeado = false;
              }
            }
          )
          
        }else{
          this.Logeado = false;
        }
    });
  }



  ngOnInit() {

    /* TODO  Al cambiar a los enrotadores del componente pages y volver a public desaparece el scroll
    esto "Parchea" ese fallo aunque hay que solucionarlo bien. La causa es que al cambiar se sobreescribe la propiedad overflow en la etiqueta body*/
    $('body').css({'overflow': 'scroll'});
    this.checkToken();
  }

  cerrarSesion(){
    this.Logeado = false;
    localStorage.clear();
    this.router.navigate(['./inicio']);
  }
  resultConsultaSocio:any;
  quieroSerSocio(){
    this._http.getAllReg("v1/conPeticionSocio/"+this.Usuario.Entidad._entidad_id).subscribe(
      result => {
        this.resultConsultaSocio = result;
        if(this.resultConsultaSocio.SolicitudesSocios > 0){
          this.utilidades.notificationWarning("Aviso","Esta pendiente de validacion","top-left");
        }else{
          let dialogRef = this.dialog.open(ModalQuieroSerSocioComponent, {
            panelClass: 'custom-dialog',
            data: {
              titulo: "User",
              entidadId: this.Usuario.Entidad._entidad_id
            }
          });
        }
      },
      error => {

      }
    );
  
  }

}
